/**
 * @fileoverview This file provides a function to convert a URL to markdown using the Jina AI Reader API. It fetches the content from the provided URL and returns the markdown text.
 */

/**
 * Use Jina AI Reader to convert a URL to markdown
 *
 * https://jina.ai/reader
 *
 * @param url - The URL to convert to markdown
 * @returns The markdown content of the URL
 */
export async function urlToMarkdown(url: string, apiKey: string | undefined = process.env.JINA_API_KEY) : Promise<{ success: true, markdown: string} | { success: false, payload: { status: number, error: string } }> {
  const response = await fetch(`https://r.jina.ai/${url}`, {
    headers: {
      Authorization: `Bearer ${apiKey}`,
    },
  })
  const text = await response.text()

  if (response.status !== 200) {
    return { success: false, payload: JSON.parse(text) }
  }
  return { success: true, markdown: text }
}
